// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[2].use[2]!../../../styles/typography.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.StandardEventTooltip--row--vdGwi {
  line-height: 16px;
  max-width: 160px;
  min-width: 120px;
  font-weight: 500;
  color: var(--stat--default);
  text-align: left;
  margin-bottom: 6px;
}

.StandardEventTooltip--row--vdGwi:last-child {
  margin-bottom: 0;
}

.StandardEventTooltip--time--cU2Uu {
  margin-bottom: 12px;
  text-align: center;
}

.StandardEventTooltip--title--czdFh {
}

.StandardEventTooltip--description--hYmkD {
  display: flex;
  justify-content: space-between;
}

.StandardEventTooltip--label--L7zf4 {
  font-weight: 700;
}

.StandardEventTooltip--value--B5GEQ {
  font-weight: 700;
}

.StandardEventTooltip--notes--pzcBE {
}

.StandardEventTooltip--note--g1jyz {
}
`, "",{"version":3,"sources":["webpack://./src/components/daily/eventtooltip/StandardEventTooltip.css"],"names":[],"mappings":"AAAA;EAEE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,2BAA2B;EAC3B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EAEE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;AAEA;;AAEA;EAEE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;AAEA;;AAEA;AAEA","sourcesContent":[".row {\n  composes: smallSize from '../../../styles/typography.css';\n  line-height: 16px;\n  max-width: 160px;\n  min-width: 120px;\n  font-weight: 500;\n  color: var(--stat--default);\n  text-align: left;\n  margin-bottom: 6px;\n}\n\n.row:last-child {\n  margin-bottom: 0;\n}\n\n.time {\n  composes: row;\n  margin-bottom: 12px;\n  text-align: center;\n}\n\n.title {\n  composes: row;\n}\n\n.description {\n  composes: row;\n  display: flex;\n  justify-content: space-between;\n}\n\n.label {\n  font-weight: 700;\n}\n\n.value {\n  font-weight: 700;\n}\n\n.notes {\n  composes: row;\n}\n\n.note {\n  composes: row;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"row": `StandardEventTooltip--row--vdGwi ${___CSS_LOADER_ICSS_IMPORT_0___.locals["smallSize"]}`,
	"time": `StandardEventTooltip--time--cU2Uu StandardEventTooltip--row--vdGwi ${___CSS_LOADER_ICSS_IMPORT_0___.locals["smallSize"]}`,
	"title": `StandardEventTooltip--title--czdFh StandardEventTooltip--row--vdGwi ${___CSS_LOADER_ICSS_IMPORT_0___.locals["smallSize"]}`,
	"description": `StandardEventTooltip--description--hYmkD StandardEventTooltip--row--vdGwi ${___CSS_LOADER_ICSS_IMPORT_0___.locals["smallSize"]}`,
	"label": `StandardEventTooltip--label--L7zf4`,
	"value": `StandardEventTooltip--value--B5GEQ`,
	"notes": `StandardEventTooltip--notes--pzcBE StandardEventTooltip--row--vdGwi ${___CSS_LOADER_ICSS_IMPORT_0___.locals["smallSize"]}`,
	"note": `StandardEventTooltip--note--g1jyz StandardEventTooltip--row--vdGwi ${___CSS_LOADER_ICSS_IMPORT_0___.locals["smallSize"]}`
};
export default ___CSS_LOADER_EXPORT___;
